export default function (state) {
  return {
    ...state,
    open: false,
  }
}
